const players = [
  {
    Number: 1,
    Last: "Hall",
    First: "Tyler",
    GP: 17,
    PA: 64,
    AB: 51,
    AVG: 0.333,
    OBP: 0.469,
    OPS: 0.822,
    SLG: 0.353,
    H: 17,
    "1B": 16,
    "2B": 1,
    "3B": 0,
    HR: 0,
    RBI: 5,
    R: 7,
    BB: 12,
    SO: 17,
    "K-L": 5,
    HBP: 1,
    SAC: 0,
    SF: 0,
    ROE: 1,
    FC: 1,
    SB: 4,
    "SB%": 66.67,
    CS: 2,
    PIK: 0,
    QAB: 35,
    "QAB%": 54.69,
    "PA/BB": 5.3,
    "BB/K": 0.706,
    "C%": 66.67,
    HHB: 17,
    "LD%": 29.41,
    "FB%": 26.47,
    "GB%": 41.18,
    BABIP: 0.5,
    "BA/RISP": 0.259,
    LOB: 45,
    "2OUTRBI": 2,
    XBH: 1,
    TB: 18,
    PS: 265,
    "PS/PA": 4.141,
    "2S+3": 10,
    "2S+3%": 15.63,
    "6+": 16,
    "6+%": 25,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 13,
    GP__1: 7,
    GS: 2,
    BF: 60,
    "#P": 196,
    W: 1,
    L: 0,
    SV: 1,
    SVO: 1,
    BS: 0,
    "SV%": 100,
    H__1: 13,
    R__1: 6,
    ER: 6,
    BB__1: 7,
    SO__1: 9,
    "K-L__1": 3,
    HBP__1: 1,
    ERA: 3.692,
    WHIP: 1.538,
    LOB__1: 14,
    BK: 0,
    PIK__1: 1,
    CS__1: 0,
    SB__1: 2,
    "SB%__1": 100,
    WP: 1,
    BAA: 0.25,
    "P/IP": 15.1,
    "P/BF": 3.267,
    "<3%": 51.67,
    LOO: 8,
    "1ST2OUT": 3,
    "123INN": 1,
    "<13": 9,
    FIP: 4.246,
    "S%": 60.2,
    "FPS%": 56.67,
    "FPSO%": 61.76,
    "FPSW%": 5.88,
    "FPSH%": 29.41,
    "BB/INN": 0.538,
    "0BBINN": 8,
    BBS: 3,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 9.18,
    "K/BF": 0.15,
    "K/BB": 1.286,
    "WEAK%": 58.14,
    "HHB%": 41.86,
    "GO/AO": 0.235,
    HR__1: 1,
    "LD%__1": 20.93,
    "FB%__1": 39.53,
    "GB%__1": 38.1,
    BABIP__1: 0.286,
    "BA/RISP__1": 0.222,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 34,
    A: 6,
    PO: 24,
    FPCT: 0.882,
    E: 4,
    DP: 1,
    TP: 0,
    INN: 12,
    PB: 3,
    SB__2: 1,
    "SB-ATT": "1-1",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 2,
    Last: "Ackerman",
    First: "Chase",
    GP: 17,
    PA: 36,
    AB: 34,
    AVG: 0.235,
    OBP: 0.278,
    OPS: 0.542,
    SLG: 0.265,
    H: 8,
    "1B": 7,
    "2B": 1,
    "3B": 0,
    HR: 0,
    RBI: 5,
    R: 8,
    BB: 2,
    SO: 10,
    "K-L": 1,
    HBP: 0,
    SAC: 0,
    SF: 0,
    ROE: 0,
    FC: 2,
    SB: 1,
    "SB%": 100,
    CS: 0,
    PIK: 0,
    QAB: 13,
    "QAB%": 36.11,
    "PA/BB": 18,
    "BB/K": 0.2,
    "C%": 70.59,
    HHB: 8,
    "LD%": 16.67,
    "FB%": 37.5,
    "GB%": 33.33,
    BABIP: 0.333,
    "BA/RISP": 0.2,
    LOB: 42,
    "2OUTRBI": 2,
    XBH: 1,
    TB: 9,
    PS: 115,
    "PS/PA": 3.194,
    "2S+3": 3,
    "2S+3%": 8.33,
    "6+": 4,
    "6+%": 11.11,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 5.2,
    GP__1: 5,
    GS: 0,
    BF: 29,
    "#P": 115,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 6,
    R__1: 7,
    ER: 2,
    BB__1: 2,
    SO__1: 8,
    "K-L__1": 1,
    HBP__1: 0,
    ERA: 2.824,
    WHIP: 1.412,
    LOB__1: 8,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 5,
    "SB%__1": 100,
    WP: 0,
    BAA: 0.222,
    "P/IP": 20.3,
    "P/BF": 3.966,
    "<3%": 37.93,
    LOO: 5,
    "1ST2OUT": 4,
    "123INN": 2,
    "<13": 3,
    FIP: 0.772,
    "S%": 60.87,
    "FPS%": 44.83,
    "FPSO%": 76.92,
    "FPSW%": 0,
    "FPSH%": 23.08,
    "BB/INN": 0.353,
    "0BBINN": 4,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 10.43,
    "K/BF": 0.276,
    "K/BB": 4,
    "WEAK%": 47.37,
    "HHB%": 52.63,
    "GO/AO": 1.333,
    HR__1: 0,
    "LD%__1": 10.53,
    "FB%__1": 26.32,
    "GB%__1": 63.16,
    BABIP__1: 0.316,
    "BA/RISP__1": 0.182,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 7,
    A: 0,
    PO: 6,
    FPCT: 0.857,
    E: 1,
    DP: 0,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 3,
    Last: "Rhoads",
    First: "Austin",
    GP: 8,
    PA: 25,
    AB: 14,
    AVG: 0.357,
    OBP: 0.64,
    OPS: 0.997,
    SLG: 0.357,
    H: 5,
    "1B": 5,
    "2B": 0,
    "3B": 0,
    HR: 0,
    RBI: 4,
    R: 5,
    BB: 9,
    SO: 4,
    "K-L": 1,
    HBP: 2,
    SAC: 0,
    SF: 0,
    ROE: 1,
    FC: 0,
    SB: 1,
    "SB%": 100,
    CS: 0,
    PIK: 0,
    QAB: 15,
    "QAB%": 60,
    "PA/BB": 2.8,
    "BB/K": 2.25,
    "C%": 71.43,
    HHB: 4,
    "LD%": 33.33,
    "FB%": 22.22,
    "GB%": 44.44,
    BABIP: 0.5,
    "BA/RISP": 0.375,
    LOB: 10,
    "2OUTRBI": 2,
    XBH: 0,
    TB: 5,
    PS: 100,
    "PS/PA": 4,
    "2S+3": 3,
    "2S+3%": 12,
    "6+": 4,
    "6+%": 16,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 0,
    GP__1: 0,
    GS: 0,
    BF: 0,
    "#P": 0,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 0,
    R__1: 0,
    ER: 0,
    BB__1: 0,
    SO__1: 0,
    "K-L__1": 0,
    HBP__1: 0,
    ERA: 0,
    WHIP: 0,
    LOB__1: 0,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 0,
    BAA: 0,
    "P/IP": 0,
    "P/BF": 0,
    "<3%": 0,
    LOO: 0,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 0,
    FIP: 0,
    "S%": 0,
    "FPS%": 0,
    "FPSO%": 0,
    "FPSW%": 0,
    "FPSH%": 0,
    "BB/INN": 0,
    "0BBINN": 0,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 0,
    "K/BF": 0,
    "K/BB": 0,
    "WEAK%": 0,
    "HHB%": 0,
    "GO/AO": 0,
    HR__1: 0,
    "LD%__1": 0,
    "FB%__1": 0,
    "GB%__1": 0,
    BABIP__1: 0,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 22,
    A: 1,
    PO: 20,
    FPCT: 0.955,
    E: 1,
    DP: 1,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 4,
    Last: "McCabe",
    First: "Brendan",
    GP: 13,
    PA: 11,
    AB: 10,
    AVG: 0.1,
    OBP: 0.182,
    OPS: 0.282,
    SLG: 0.1,
    H: 1,
    "1B": 1,
    "2B": 0,
    "3B": 0,
    HR: 0,
    RBI: 2,
    R: 6,
    BB: 1,
    SO: 0,
    "K-L": 0,
    HBP: 0,
    SAC: 0,
    SF: 0,
    ROE: 3,
    FC: 2,
    SB: 1,
    "SB%": 33.33,
    CS: 2,
    PIK: 0,
    QAB: 5,
    "QAB%": 45.45,
    "PA/BB": 11,
    "BB/K": 0,
    "C%": 100,
    HHB: 4,
    "LD%": 10,
    "FB%": 30,
    "GB%": 50,
    BABIP: 0.1,
    "BA/RISP": 0,
    LOB: 13,
    "2OUTRBI": 0,
    XBH: 0,
    TB: 1,
    PS: 29,
    "PS/PA": 2.636,
    "2S+3": 1,
    "2S+3%": 9.09,
    "6+": 1,
    "6+%": 9.09,
    "AB/HR": 0,
    GIDP: 1,
    GITP: 0,
    CI: 0,
    IP: 1,
    GP__1: 2,
    GS: 0,
    BF: 5,
    "#P": 19,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 0,
    R__1: 0,
    ER: 0,
    BB__1: 2,
    SO__1: 0,
    "K-L__1": 0,
    HBP__1: 0,
    ERA: 0,
    WHIP: 2,
    LOB__1: 2,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 0,
    BAA: 0,
    "P/IP": 19,
    "P/BF": 3.8,
    "<3%": 40,
    LOO: 1,
    "1ST2OUT": 1,
    "123INN": 0,
    "<13": 0,
    FIP: 9.28,
    "S%": 47.37,
    "FPS%": 60,
    "FPSO%": 100,
    "FPSW%": 0,
    "FPSH%": 0,
    "BB/INN": 2,
    "0BBINN": 0,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 10.53,
    "K/BF": 0,
    "K/BB": 0,
    "WEAK%": 100,
    "HHB%": 0,
    "GO/AO": 0.5,
    HR__1: 0,
    "LD%__1": 0,
    "FB%__1": 66.67,
    "GB%__1": 33.33,
    BABIP__1: 0,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 14,
    A: 5,
    PO: 9,
    FPCT: 1,
    E: 0,
    DP: 1,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 5,
    Last: "Pahel",
    First: "Jacob",
    GP: 18,
    PA: 72,
    AB: 47,
    AVG: 0.234,
    OBP: 0.5,
    OPS: 0.777,
    SLG: 0.277,
    H: 11,
    "1B": 9,
    "2B": 2,
    "3B": 0,
    HR: 0,
    RBI: 5,
    R: 14,
    BB: 19,
    SO: 14,
    "K-L": 6,
    HBP: 6,
    SAC: 0,
    SF: 0,
    ROE: 3,
    FC: 4,
    SB: 4,
    "SB%": 80,
    CS: 1,
    PIK: 0,
    QAB: 45,
    "QAB%": 62.5,
    "PA/BB": 3.8,
    "BB/K": 1.357,
    "C%": 70.21,
    HHB: 17,
    "LD%": 24.24,
    "FB%": 33.33,
    "GB%": 42.42,
    BABIP: 0.333,
    "BA/RISP": 0.19,
    LOB: 40,
    "2OUTRBI": 0,
    XBH: 2,
    TB: 13,
    PS: 286,
    "PS/PA": 3.972,
    "2S+3": 15,
    "2S+3%": 20.83,
    "6+": 21,
    "6+%": 29.17,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 0.2,
    GP__1: 1,
    GS: 0,
    BF: 3,
    "#P": 11,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 1,
    R__1: 0,
    ER: 0,
    BB__1: 0,
    SO__1: 0,
    "K-L__1": 0,
    HBP__1: 0,
    ERA: 0,
    WHIP: 1.5,
    LOB__1: 1,
    BK: 1,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 1,
    "SB%__1": 100,
    WP: 0,
    BAA: 0.333,
    "P/IP": 16.5,
    "P/BF": 3.667,
    "<3%": 33.33,
    LOO: 0,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 0,
    FIP: 3.2,
    "S%": 63.64,
    "FPS%": 66.67,
    "FPSO%": 50,
    "FPSW%": 0,
    "FPSH%": 50,
    "BB/INN": 0,
    "0BBINN": 1,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 9.09,
    "K/BF": 0,
    "K/BB": 0,
    "WEAK%": 33.33,
    "HHB%": 66.67,
    "GO/AO": 0,
    HR__1: 0,
    "LD%__1": 0,
    "FB%__1": 33.33,
    "GB%__1": 66.67,
    BABIP__1: 0.333,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 26,
    A: 0,
    PO: 24,
    FPCT: 0.923,
    E: 2,
    DP: 0,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 6,
    Last: "Lee",
    First: "Peyton",
    GP: 7,
    PA: 13,
    AB: 8,
    AVG: 0.25,
    OBP: 0.538,
    OPS: 0.788,
    SLG: 0.25,
    H: 2,
    "1B": 2,
    "2B": 0,
    "3B": 0,
    HR: 0,
    RBI: 0,
    R: 2,
    BB: 4,
    SO: 5,
    "K-L": 2,
    HBP: 1,
    SAC: 0,
    SF: 0,
    ROE: 0,
    FC: 0,
    SB: 1,
    "SB%": 50,
    CS: 1,
    PIK: 2,
    QAB: 7,
    "QAB%": 53.85,
    "PA/BB": 3.3,
    "BB/K": 0.8,
    "C%": 37.5,
    HHB: 2,
    "LD%": 66.67,
    "FB%": 0,
    "GB%": 33.33,
    BABIP: 0.667,
    "BA/RISP": 0,
    LOB: 7,
    "2OUTRBI": 0,
    XBH: 0,
    TB: 2,
    PS: 55,
    "PS/PA": 4.231,
    "2S+3": 2,
    "2S+3%": 15.38,
    "6+": 3,
    "6+%": 23.08,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 0,
    GP__1: 0,
    GS: 0,
    BF: 0,
    "#P": 0,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 0,
    R__1: 0,
    ER: 0,
    BB__1: 0,
    SO__1: 0,
    "K-L__1": 0,
    HBP__1: 0,
    ERA: 0,
    WHIP: 0,
    LOB__1: 0,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 0,
    BAA: 0,
    "P/IP": 0,
    "P/BF": 0,
    "<3%": 0,
    LOO: 0,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 0,
    FIP: 0,
    "S%": 0,
    "FPS%": 0,
    "FPSO%": 0,
    "FPSW%": 0,
    "FPSH%": 0,
    "BB/INN": 0,
    "0BBINN": 0,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 0,
    "K/BF": 0,
    "K/BB": 0,
    "WEAK%": 0,
    "HHB%": 0,
    "GO/AO": 0,
    HR__1: 0,
    "LD%__1": 0,
    "FB%__1": 0,
    "GB%__1": 0,
    BABIP__1: 0,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 1,
    A: 0,
    PO: 1,
    FPCT: 1,
    E: 0,
    DP: 0,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 7,
    Last: "Gomes",
    First: "Javone",
    GP: 13,
    PA: 16,
    AB: 7,
    AVG: 0.143,
    OBP: 0.625,
    OPS: 0.768,
    SLG: 0.143,
    H: 1,
    "1B": 1,
    "2B": 0,
    "3B": 0,
    HR: 0,
    RBI: 1,
    R: 7,
    BB: 9,
    SO: 2,
    "K-L": 0,
    HBP: 0,
    SAC: 0,
    SF: 0,
    ROE: 2,
    FC: 0,
    SB: 5,
    "SB%": 71.43,
    CS: 2,
    PIK: 0,
    QAB: 11,
    "QAB%": 68.75,
    "PA/BB": 1.8,
    "BB/K": 4.5,
    "C%": 71.43,
    HHB: 1,
    "LD%": 0,
    "FB%": 25,
    "GB%": 75,
    BABIP: 0.2,
    "BA/RISP": 0,
    LOB: 10,
    "2OUTRBI": 0,
    XBH: 0,
    TB: 1,
    PS: 57,
    "PS/PA": 3.563,
    "2S+3": 0,
    "2S+3%": 0,
    "6+": 2,
    "6+%": 12.5,
    "AB/HR": 0,
    GIDP: 1,
    GITP: 0,
    CI: 0,
    IP: 0,
    GP__1: 0,
    GS: 0,
    BF: 0,
    "#P": 0,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 0,
    R__1: 0,
    ER: 0,
    BB__1: 0,
    SO__1: 0,
    "K-L__1": 0,
    HBP__1: 0,
    ERA: 0,
    WHIP: 0,
    LOB__1: 0,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 0,
    BAA: 0,
    "P/IP": 0,
    "P/BF": 0,
    "<3%": 0,
    LOO: 0,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 0,
    FIP: 0,
    "S%": 0,
    "FPS%": 0,
    "FPSO%": 0,
    "FPSW%": 0,
    "FPSH%": 0,
    "BB/INN": 0,
    "0BBINN": 0,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 0,
    "K/BF": 0,
    "K/BB": 0,
    "WEAK%": 0,
    "HHB%": 0,
    "GO/AO": 0,
    HR__1: 0,
    "LD%__1": 0,
    "FB%__1": 0,
    "GB%__1": 0,
    BABIP__1: 0,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 6,
    A: 3,
    PO: 2,
    FPCT: 0.833,
    E: 1,
    DP: 1,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 8,
    Last: "Michael",
    First: "Nathan",
    GP: 12,
    PA: 25,
    AB: 20,
    AVG: 0.35,
    OBP: 0.458,
    OPS: 0.858,
    SLG: 0.4,
    H: 7,
    "1B": 6,
    "2B": 1,
    "3B": 0,
    HR: 0,
    RBI: 6,
    R: 2,
    BB: 1,
    SO: 4,
    "K-L": 1,
    HBP: 3,
    SAC: 1,
    SF: 0,
    ROE: 1,
    FC: 0,
    SB: 1,
    "SB%": 100,
    CS: 0,
    PIK: 1,
    QAB: 12,
    "QAB%": 48,
    "PA/BB": 25,
    "BB/K": 0.25,
    "C%": 80,
    HHB: 7,
    "LD%": 35.29,
    "FB%": 23.53,
    "GB%": 35.29,
    BABIP: 0.438,
    "BA/RISP": 0.556,
    LOB: 8,
    "2OUTRBI": 3,
    XBH: 1,
    TB: 8,
    PS: 91,
    "PS/PA": 3.64,
    "2S+3": 1,
    "2S+3%": 4,
    "6+": 3,
    "6+%": 12,
    "AB/HR": 0,
    GIDP: 1,
    GITP: 0,
    CI: 0,
    IP: 2.1,
    GP__1: 4,
    GS: 0,
    BF: 13,
    "#P": 52,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 2,
    R__1: 1,
    ER: 1,
    BB__1: 4,
    SO__1: 5,
    "K-L__1": 1,
    HBP__1: 0,
    ERA: 3.429,
    WHIP: 2.571,
    LOB__1: 2,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 3,
    "SB%__1": 100,
    WP: 0,
    BAA: 0.222,
    "P/IP": 22.3,
    "P/BF": 4,
    "<3%": 30.77,
    LOO: 2,
    "1ST2OUT": 1,
    "123INN": 1,
    "<13": 1,
    FIP: 3.097,
    "S%": 53.85,
    "FPS%": 53.85,
    "FPSO%": 85.71,
    "FPSW%": 14.29,
    "FPSH%": 14.29,
    "BB/INN": 1.714,
    "0BBINN": 2,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 19.23,
    "K/BF": 0.385,
    "K/BB": 1.25,
    "WEAK%": 25,
    "HHB%": 75,
    "GO/AO": 0,
    HR__1: 0,
    "LD%__1": 25,
    "FB%__1": 0,
    "GB%__1": 75,
    BABIP__1: 0.5,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 14,
    A: 5,
    PO: 8,
    FPCT: 0.929,
    E: 1,
    DP: 1,
    TP: 0,
    INN: 2,
    PB: 1,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 9,
    Last: "Wood",
    First: "Desmond",
    GP: 13,
    PA: 32,
    AB: 22,
    AVG: 0.182,
    OBP: 0.438,
    OPS: 0.619,
    SLG: 0.182,
    H: 4,
    "1B": 4,
    "2B": 0,
    "3B": 0,
    HR: 0,
    RBI: 5,
    R: 6,
    BB: 10,
    SO: 10,
    "K-L": 4,
    HBP: 0,
    SAC: 0,
    SF: 0,
    ROE: 1,
    FC: 0,
    SB: 4,
    "SB%": 100,
    CS: 0,
    PIK: 0,
    QAB: 20,
    "QAB%": 62.5,
    "PA/BB": 3.2,
    "BB/K": 1,
    "C%": 54.55,
    HHB: 5,
    "LD%": 8.33,
    "FB%": 33.33,
    "GB%": 50,
    BABIP: 0.333,
    "BA/RISP": 0.429,
    LOB: 11,
    "2OUTRBI": 1,
    XBH: 0,
    TB: 4,
    PS: 156,
    "PS/PA": 4.875,
    "2S+3": 11,
    "2S+3%": 34.38,
    "6+": 13,
    "6+%": 40.63,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 0,
    GP__1: 0,
    GS: 0,
    BF: 0,
    "#P": 0,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 0,
    R__1: 0,
    ER: 0,
    BB__1: 0,
    SO__1: 0,
    "K-L__1": 0,
    HBP__1: 0,
    ERA: 0,
    WHIP: 0,
    LOB__1: 0,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 0,
    BAA: 0,
    "P/IP": 0,
    "P/BF": 0,
    "<3%": 0,
    LOO: 0,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 0,
    FIP: 0,
    "S%": 0,
    "FPS%": 0,
    "FPSO%": 0,
    "FPSW%": 0,
    "FPSH%": 0,
    "BB/INN": 0,
    "0BBINN": 0,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 0,
    "K/BF": 0,
    "K/BB": 0,
    "WEAK%": 0,
    "HHB%": 0,
    "GO/AO": 0,
    HR__1: 0,
    "LD%__1": 0,
    "FB%__1": 0,
    "GB%__1": 0,
    BABIP__1: 0,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 27,
    A: 1,
    PO: 23,
    FPCT: 0.889,
    E: 3,
    DP: 1,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 11,
    Last: "Shelton",
    First: "Robbie",
    GP: 19,
    PA: 72,
    AB: 59,
    AVG: 0.339,
    OBP: 0.458,
    OPS: 1.153,
    SLG: 0.695,
    H: 20,
    "1B": 10,
    "2B": 3,
    "3B": 3,
    HR: 4,
    RBI: 22,
    R: 17,
    BB: 11,
    SO: 16,
    "K-L": 5,
    HBP: 2,
    SAC: 0,
    SF: 0,
    ROE: 2,
    FC: 3,
    SB: 5,
    "SB%": 100,
    CS: 0,
    PIK: 0,
    QAB: 40,
    "QAB%": 55.56,
    "PA/BB": 6.5,
    "BB/K": 0.688,
    "C%": 72.88,
    HHB: 21,
    "LD%": 16.28,
    "FB%": 41.86,
    "GB%": 41.86,
    BABIP: 0.41,
    "BA/RISP": 0.444,
    LOB: 36,
    "2OUTRBI": 6,
    XBH: 10,
    TB: 41,
    PS: 279,
    "PS/PA": 3.875,
    "2S+3": 11,
    "2S+3%": 15.28,
    "6+": 12,
    "6+%": 16.67,
    "AB/HR": 14.8,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 5,
    GP__1: 5,
    GS: 2,
    BF: 32,
    "#P": 129,
    W: 0,
    L: 0,
    SV: 1,
    SVO: 1,
    BS: 0,
    "SV%": 100,
    H__1: 5,
    R__1: 7,
    ER: 5,
    BB__1: 9,
    SO__1: 7,
    "K-L__1": 3,
    HBP__1: 0,
    ERA: 8,
    WHIP: 2.8,
    LOB__1: 12,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 1,
    "SB%__1": 100,
    WP: 0,
    BAA: 0.217,
    "P/IP": 25.8,
    "P/BF": 4.031,
    "<3%": 34.38,
    LOO: 3,
    "1ST2OUT": 3,
    "123INN": 0,
    "<13": 1,
    FIP: 5.2,
    "S%": 51.94,
    "FPS%": 46.88,
    "FPSO%": 66.67,
    "FPSW%": 13.33,
    "FPSH%": 20,
    "BB/INN": 1.8,
    "0BBINN": 2,
    BBS: 4,
    LOBB: 2,
    LOBBS: 2,
    "SM%": 7.75,
    "K/BF": 0.219,
    "K/BB": 0.778,
    "WEAK%": 62.5,
    "HHB%": 37.5,
    "GO/AO": 1,
    HR__1: 0,
    "LD%__1": 18.75,
    "FB%__1": 37.5,
    "GB%__1": 43.75,
    BABIP__1: 0.313,
    "BA/RISP__1": 0.182,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 44,
    A: 17,
    PO: 21,
    FPCT: 0.864,
    E: 6,
    DP: 0,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 12,
    Last: "Bowling",
    First: "Adam",
    GP: 10,
    PA: 16,
    AB: 12,
    AVG: 0.167,
    OBP: 0.375,
    OPS: 0.542,
    SLG: 0.167,
    H: 2,
    "1B": 2,
    "2B": 0,
    "3B": 0,
    HR: 0,
    RBI: 1,
    R: 3,
    BB: 4,
    SO: 1,
    "K-L": 0,
    HBP: 0,
    SAC: 0,
    SF: 0,
    ROE: 3,
    FC: 1,
    SB: 2,
    "SB%": 100,
    CS: 0,
    PIK: 0,
    QAB: 5,
    "QAB%": 31.25,
    "PA/BB": 4,
    "BB/K": 4,
    "C%": 91.67,
    HHB: 1,
    "LD%": 9.09,
    "FB%": 63.64,
    "GB%": 27.27,
    BABIP: 0.182,
    "BA/RISP": 0,
    LOB: 11,
    "2OUTRBI": 0,
    XBH: 0,
    TB: 2,
    PS: 53,
    "PS/PA": 3.313,
    "2S+3": 1,
    "2S+3%": 6.25,
    "6+": 1,
    "6+%": 6.25,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 16.2,
    GP__1: 11,
    GS: 0,
    BF: 87,
    "#P": 304,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 22,
    R__1: 13,
    ER: 10,
    BB__1: 13,
    SO__1: 12,
    "K-L__1": 3,
    HBP__1: 2,
    ERA: 4.8,
    WHIP: 2.1,
    LOB__1: 26,
    BK: 0,
    PIK__1: 0,
    CS__1: 1,
    SB__1: 6,
    "SB%__1": 85.71,
    WP: 1,
    BAA: 0.314,
    "P/IP": 18.2,
    "P/BF": 3.494,
    "<3%": 52.87,
    LOO: 8,
    "1ST2OUT": 4,
    "123INN": 0,
    "<13": 4,
    FIP: 4.15,
    "S%": 57.24,
    "FPS%": 40.23,
    "FPSO%": 65.71,
    "FPSW%": 2.86,
    "FPSH%": 28.57,
    "BB/INN": 0.78,
    "0BBINN": 10,
    BBS: 2,
    LOBB: 1,
    LOBBS: 0,
    "SM%": 9.54,
    "K/BF": 0.138,
    "K/BB": 0.923,
    "WEAK%": 51.67,
    "HHB%": 48.33,
    "GO/AO": 0.647,
    HR__1: 0,
    "LD%__1": 21.67,
    "FB%__1": 28.33,
    "GB%__1": 48.28,
    BABIP__1: 0.373,
    "BA/RISP__1": 0.25,
    FB: 16,
    FBS: 8,
    "FBS%": 50,
    "FBSW%": 25,
    "FBSM%": 6.25,
    CB: 9,
    CBS: 5,
    "CBS%": 55.56,
    "CBSW%": 44.44,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 5,
    CHS: 2,
    "CHS%": 40,
    "CHSW%": 40,
    "CHSM%": 20,
    OS: 14,
    OSS: 7,
    "OSS%": 50,
    "OSSW%": 42.86,
    "OSSM%": 7.14,
    TC: 17,
    A: 8,
    PO: 7,
    FPCT: 0.882,
    E: 2,
    DP: 1,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 14,
    Last: "Scopp",
    First: "Timmy",
    GP: 4,
    PA: 3,
    AB: 3,
    AVG: 0.333,
    OBP: 0.333,
    OPS: 0.667,
    SLG: 0.333,
    H: 1,
    "1B": 1,
    "2B": 0,
    "3B": 0,
    HR: 0,
    RBI: 2,
    R: 3,
    BB: 0,
    SO: 0,
    "K-L": 0,
    HBP: 0,
    SAC: 0,
    SF: 0,
    ROE: 0,
    FC: 0,
    SB: 1,
    "SB%": 100,
    CS: 0,
    PIK: 0,
    QAB: 2,
    "QAB%": 66.67,
    "PA/BB": 0,
    "BB/K": 0,
    "C%": 100,
    HHB: 2,
    "LD%": 50,
    "FB%": 0,
    "GB%": 50,
    BABIP: 0.333,
    "BA/RISP": 0.5,
    LOB: 0,
    "2OUTRBI": 0,
    XBH: 0,
    TB: 1,
    PS: 8,
    "PS/PA": 2.667,
    "2S+3": 1,
    "2S+3%": 33.33,
    "6+": 1,
    "6+%": 33.33,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 12.2,
    GP__1: 6,
    GS: 1,
    BF: 56,
    "#P": 206,
    W: 1,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 7,
    R__1: 9,
    ER: 7,
    BB__1: 7,
    SO__1: 17,
    "K-L__1": 6,
    HBP__1: 2,
    ERA: 4.421,
    WHIP: 1.105,
    LOB__1: 11,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 4,
    "SB%__1": 100,
    WP: 0,
    BAA: 0.149,
    "P/IP": 16.3,
    "P/BF": 3.679,
    "<3%": 44.64,
    LOO: 8,
    "1ST2OUT": 6,
    "123INN": 3,
    "<13": 3,
    FIP: 2.032,
    "S%": 59.71,
    "FPS%": 62.5,
    "FPSO%": 80,
    "FPSW%": 2.86,
    "FPSH%": 11.43,
    "BB/INN": 0.553,
    "0BBINN": 7,
    BBS: 4,
    LOBB: 1,
    LOBBS: 1,
    "SM%": 15.05,
    "K/BF": 0.304,
    "K/BB": 2.429,
    "WEAK%": 60,
    "HHB%": 40,
    "GO/AO": 0.667,
    HR__1: 0,
    "LD%__1": 16.67,
    "FB%__1": 43.33,
    "GB%__1": 37.93,
    BABIP__1: 0.233,
    "BA/RISP__1": 0.19,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 2,
    A: 2,
    PO: 0,
    FPCT: 1,
    E: 0,
    DP: 0,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 16,
    Last: "Mehall",
    First: "Joeyy",
    GP: 1,
    PA: 0,
    AB: 0,
    AVG: 0,
    OBP: 0,
    OPS: 0,
    SLG: 0,
    H: 0,
    "1B": 0,
    "2B": 0,
    "3B": 0,
    HR: 0,
    RBI: 0,
    R: 0,
    BB: 0,
    SO: 0,
    "K-L": 0,
    HBP: 0,
    SAC: 0,
    SF: 0,
    ROE: 0,
    FC: 0,
    SB: 0,
    "SB%": 0,
    CS: 0,
    PIK: 0,
    QAB: 0,
    "QAB%": 0,
    "PA/BB": 0,
    "BB/K": 0,
    "C%": 0,
    HHB: 0,
    "LD%": 0,
    "FB%": 0,
    "GB%": 0,
    BABIP: 0,
    "BA/RISP": 0,
    LOB: 0,
    "2OUTRBI": 0,
    XBH: 0,
    TB: 0,
    PS: 0,
    "PS/PA": 0,
    "2S+3": 0,
    "2S+3%": 0,
    "6+": 0,
    "6+%": 0,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 0,
    GP__1: 0,
    GS: 0,
    BF: 0,
    "#P": 0,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 0,
    R__1: 0,
    ER: 0,
    BB__1: 0,
    SO__1: 0,
    "K-L__1": 0,
    HBP__1: 0,
    ERA: 0,
    WHIP: 0,
    LOB__1: 0,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 0,
    BAA: 0,
    "P/IP": 0,
    "P/BF": 0,
    "<3%": 0,
    LOO: 0,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 0,
    FIP: 0,
    "S%": 0,
    "FPS%": 0,
    "FPSO%": 0,
    "FPSW%": 0,
    "FPSH%": 0,
    "BB/INN": 0,
    "0BBINN": 0,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 0,
    "K/BF": 0,
    "K/BB": 0,
    "WEAK%": 0,
    "HHB%": 0,
    "GO/AO": 0,
    HR__1: 0,
    "LD%__1": 0,
    "FB%__1": 0,
    "GB%__1": 0,
    BABIP__1: 0,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 2,
    A: 0,
    PO: 2,
    FPCT: 1,
    E: 0,
    DP: 0,
    TP: 0,
    INN: 2.1,
    PB: 0,
    SB__2: 2,
    "SB-ATT": "2-3",
    CS__2: 1,
    "CS%": 33.33,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 16,
    Last: "Mehall",
    First: "Joey",
    GP: 2,
    PA: 4,
    AB: 4,
    AVG: 0,
    OBP: 0,
    OPS: 0,
    SLG: 0,
    H: 0,
    "1B": 0,
    "2B": 0,
    "3B": 0,
    HR: 0,
    RBI: 0,
    R: 0,
    BB: 0,
    SO: 2,
    "K-L": 1,
    HBP: 0,
    SAC: 0,
    SF: 0,
    ROE: 0,
    FC: 0,
    SB: 0,
    "SB%": 0,
    CS: 0,
    PIK: 0,
    QAB: 1,
    "QAB%": 25,
    "PA/BB": 0,
    "BB/K": 0,
    "C%": 50,
    HHB: 1,
    "LD%": 50,
    "FB%": 50,
    "GB%": 0,
    BABIP: 0,
    "BA/RISP": 0,
    LOB: 4,
    "2OUTRBI": 0,
    XBH: 0,
    TB: 0,
    PS: 11,
    "PS/PA": 2.75,
    "2S+3": 0,
    "2S+3%": 0,
    "6+": 0,
    "6+%": 0,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 0,
    GP__1: 1,
    GS: 0,
    BF: 0,
    "#P": 0,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 0,
    R__1: 0,
    ER: 0,
    BB__1: 0,
    SO__1: 0,
    "K-L__1": 0,
    HBP__1: 0,
    ERA: 0,
    WHIP: 0,
    LOB__1: 0,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 0,
    BAA: 0,
    "P/IP": 0,
    "P/BF": 0,
    "<3%": 0,
    LOO: 0,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 0,
    FIP: 0,
    "S%": 0,
    "FPS%": 0,
    "FPSO%": 0,
    "FPSW%": 0,
    "FPSH%": 0,
    "BB/INN": 0,
    "0BBINN": 0,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 0,
    "K/BF": 0,
    "K/BB": 0,
    "WEAK%": 0,
    "HHB%": 0,
    "GO/AO": 0,
    HR__1: 0,
    "LD%__1": 0,
    "FB%__1": 0,
    "GB%__1": 0,
    BABIP__1: 0,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 15,
    A: 0,
    PO: 15,
    FPCT: 1,
    E: 0,
    DP: 0,
    TP: 0,
    INN: 6.2,
    PB: 0,
    SB__2: 1,
    "SB-ATT": "1-1",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 17,
    Last: "Bowling",
    First: "Chet",
    GP: 19,
    PA: 76,
    AB: 59,
    AVG: 0.322,
    OBP: 0.474,
    OPS: 1.152,
    SLG: 0.678,
    H: 19,
    "1B": 8,
    "2B": 6,
    "3B": 0,
    HR: 5,
    RBI: 20,
    R: 15,
    BB: 11,
    SO: 15,
    "K-L": 2,
    HBP: 6,
    SAC: 0,
    SF: 0,
    ROE: 3,
    FC: 2,
    SB: 7,
    "SB%": 87.5,
    CS: 1,
    PIK: 0,
    QAB: 43,
    "QAB%": 56.58,
    "PA/BB": 6.9,
    "BB/K": 0.733,
    "C%": 74.58,
    HHB: 25,
    "LD%": 33.33,
    "FB%": 40,
    "GB%": 26.67,
    BABIP: 0.359,
    "BA/RISP": 0.273,
    LOB: 38,
    "2OUTRBI": 3,
    XBH: 11,
    TB: 40,
    PS: 261,
    "PS/PA": 3.434,
    "2S+3": 9,
    "2S+3%": 11.84,
    "6+": 9,
    "6+%": 11.84,
    "AB/HR": 11.8,
    GIDP: 1,
    GITP: 0,
    CI: 0,
    IP: 2.2,
    GP__1: 2,
    GS: 1,
    BF: 20,
    "#P": 71,
    W: 0,
    L: 1,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 5,
    R__1: 8,
    ER: 4,
    BB__1: 3,
    SO__1: 2,
    "K-L__1": 0,
    HBP__1: 0,
    ERA: 12,
    WHIP: 3,
    LOB__1: 3,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 1,
    BAA: 0.294,
    "P/IP": 26.6,
    "P/BF": 3.55,
    "<3%": 55,
    LOO: 1,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 0,
    FIP: 4.76,
    "S%": 56.34,
    "FPS%": 55,
    "FPSO%": 72.73,
    "FPSW%": 0,
    "FPSH%": 27.27,
    "BB/INN": 1.125,
    "0BBINN": 1,
    BBS: 2,
    LOBB: 1,
    LOBBS: 1,
    "SM%": 9.86,
    "K/BF": 0.1,
    "K/BB": 0.667,
    "WEAK%": 73.33,
    "HHB%": 26.67,
    "GO/AO": 0.5,
    HR__1: 0,
    "LD%__1": 13.33,
    "FB%__1": 46.67,
    "GB%__1": 40,
    BABIP__1: 0.333,
    "BA/RISP__1": 0.231,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 86,
    A: 15,
    PO: 70,
    FPCT: 0.988,
    E: 1,
    DP: 4,
    TP: 0,
    INN: 55.1,
    PB: 13,
    SB__2: 14,
    "SB-ATT": "14-16",
    CS__2: 2,
    "CS%": 12.5,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 18,
    Last: "King",
    First: "Dominic",
    GP: 17,
    PA: 51,
    AB: 43,
    AVG: 0.233,
    OBP: 0.353,
    OPS: 0.655,
    SLG: 0.302,
    H: 10,
    "1B": 7,
    "2B": 3,
    "3B": 0,
    HR: 0,
    RBI: 4,
    R: 13,
    BB: 6,
    SO: 8,
    "K-L": 1,
    HBP: 2,
    SAC: 0,
    SF: 0,
    ROE: 3,
    FC: 2,
    SB: 0,
    "SB%": 0,
    CS: 0,
    PIK: 0,
    QAB: 29,
    "QAB%": 56.86,
    "PA/BB": 8.5,
    "BB/K": 0.75,
    "C%": 81.4,
    HHB: 19,
    "LD%": 25.71,
    "FB%": 22.86,
    "GB%": 51.43,
    BABIP: 0.286,
    "BA/RISP": 0.133,
    LOB: 27,
    "2OUTRBI": 0,
    XBH: 3,
    TB: 13,
    PS: 188,
    "PS/PA": 3.686,
    "2S+3": 8,
    "2S+3%": 15.69,
    "6+": 8,
    "6+%": 15.69,
    "AB/HR": 0,
    GIDP: 1,
    GITP: 0,
    CI: 0,
    IP: 2,
    GP__1: 2,
    GS: 0,
    BF: 9,
    "#P": 25,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 1,
    R__1: 0,
    ER: 0,
    BB__1: 0,
    SO__1: 1,
    "K-L__1": 0,
    HBP__1: 1,
    ERA: 0,
    WHIP: 0.5,
    LOB__1: 3,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 0,
    BAA: 0.125,
    "P/IP": 12.5,
    "P/BF": 2.778,
    "<3%": 55.56,
    LOO: 2,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 1,
    FIP: 3.48,
    "S%": 64,
    "FPS%": 55.56,
    "FPSO%": 80,
    "FPSW%": 0,
    "FPSH%": 20,
    "BB/INN": 0,
    "0BBINN": 2,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 4,
    "K/BF": 0.111,
    "K/BB": 0,
    "WEAK%": 57.14,
    "HHB%": 42.86,
    "GO/AO": 0.667,
    HR__1: 0,
    "LD%__1": 0,
    "FB%__1": 42.86,
    "GB%__1": 57.14,
    BABIP__1: 0.143,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 75,
    A: 4,
    PO: 71,
    FPCT: 1,
    E: 0,
    DP: 6,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 19,
    Last: "Coombs",
    First: "Chris",
    GP: 17,
    PA: 67,
    AB: 56,
    AVG: 0.357,
    OBP: 0.463,
    OPS: 0.927,
    SLG: 0.464,
    H: 20,
    "1B": 14,
    "2B": 6,
    "3B": 0,
    HR: 0,
    RBI: 15,
    R: 6,
    BB: 10,
    SO: 11,
    "K-L": 3,
    HBP: 1,
    SAC: 0,
    SF: 0,
    ROE: 6,
    FC: 3,
    SB: 5,
    "SB%": 100,
    CS: 0,
    PIK: 1,
    QAB: 42,
    "QAB%": 62.69,
    "PA/BB": 6.7,
    "BB/K": 0.909,
    "C%": 80.36,
    HHB: 26,
    "LD%": 28.89,
    "FB%": 28.89,
    "GB%": 42.22,
    BABIP: 0.444,
    "BA/RISP": 0.429,
    LOB: 28,
    "2OUTRBI": 6,
    XBH: 6,
    TB: 26,
    PS: 246,
    "PS/PA": 3.672,
    "2S+3": 7,
    "2S+3%": 10.45,
    "6+": 13,
    "6+%": 19.4,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 34.1,
    GP__1: 9,
    GS: 7,
    BF: 150,
    "#P": 489,
    W: 5,
    L: 2,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 31,
    R__1: 19,
    ER: 11,
    BB__1: 9,
    SO__1: 30,
    "K-L__1": 9,
    HBP__1: 4,
    ERA: 2.563,
    WHIP: 1.165,
    LOB__1: 25,
    BK: 2,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 4,
    "SB%__1": 100,
    WP: 0,
    BAA: 0.226,
    "P/IP": 14.2,
    "P/BF": 3.26,
    "<3%": 56.67,
    LOO: 29,
    "1ST2OUT": 18,
    "123INN": 11,
    "<13": 20,
    FIP: 2.522,
    "S%": 69.33,
    "FPS%": 74,
    "FPSO%": 73.87,
    "FPSW%": 2.7,
    "FPSH%": 21.62,
    "BB/INN": 0.262,
    "0BBINN": 27,
    BBS: 2,
    LOBB: 1,
    LOBBS: 0,
    "SM%": 10.22,
    "K/BF": 0.2,
    "K/BB": 3.333,
    "WEAK%": 61.68,
    "HHB%": 38.32,
    "GO/AO": 0.512,
    HR__1: 1,
    "LD%__1": 15.89,
    "FB%__1": 39.25,
    "GB%__1": 43.27,
    BABIP__1: 0.283,
    "BA/RISP__1": 0.375,
    FB: 10,
    FBS: 9,
    "FBS%": 90,
    "FBSW%": 90,
    "FBSM%": 40,
    CB: 6,
    CBS: 5,
    "CBS%": 83.33,
    "CBSW%": 16.67,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 1,
    CHS: 1,
    "CHS%": 100,
    "CHSW%": 100,
    "CHSM%": 0,
    OS: 7,
    OSS: 6,
    "OSS%": 85.71,
    "OSSW%": 28.57,
    "OSSM%": 0,
    TC: 45,
    A: 28,
    PO: 10,
    FPCT: 0.844,
    E: 7,
    DP: 1,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 20,
    Last: "Hebner",
    First: "Mason",
    GP: 13,
    PA: 27,
    AB: 21,
    AVG: 0.238,
    OBP: 0.407,
    OPS: 0.693,
    SLG: 0.286,
    H: 5,
    "1B": 4,
    "2B": 1,
    "3B": 0,
    HR: 0,
    RBI: 2,
    R: 5,
    BB: 6,
    SO: 10,
    "K-L": 3,
    HBP: 0,
    SAC: 0,
    SF: 0,
    ROE: 1,
    FC: 0,
    SB: 0,
    "SB%": 0,
    CS: 0,
    PIK: 0,
    QAB: 16,
    "QAB%": 59.26,
    "PA/BB": 4.5,
    "BB/K": 0.6,
    "C%": 52.38,
    HHB: 6,
    "LD%": 18.18,
    "FB%": 0,
    "GB%": 81.82,
    BABIP: 0.455,
    "BA/RISP": 0.25,
    LOB: 14,
    "2OUTRBI": 1,
    XBH: 1,
    TB: 6,
    PS: 112,
    "PS/PA": 4.148,
    "2S+3": 3,
    "2S+3%": 11.11,
    "6+": 9,
    "6+%": 33.33,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 0,
    GP__1: 0,
    GS: 0,
    BF: 0,
    "#P": 0,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 0,
    R__1: 0,
    ER: 0,
    BB__1: 0,
    SO__1: 0,
    "K-L__1": 0,
    HBP__1: 0,
    ERA: 0,
    WHIP: 0,
    LOB__1: 0,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 0,
    BAA: 0,
    "P/IP": 0,
    "P/BF": 0,
    "<3%": 0,
    LOO: 0,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 0,
    FIP: 0,
    "S%": 0,
    "FPS%": 0,
    "FPSO%": 0,
    "FPSW%": 0,
    "FPSH%": 0,
    "BB/INN": 0,
    "0BBINN": 0,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 0,
    "K/BF": 0,
    "K/BB": 0,
    "WEAK%": 0,
    "HHB%": 0,
    "GO/AO": 0,
    HR__1: 0,
    "LD%__1": 0,
    "FB%__1": 0,
    "GB%__1": 0,
    BABIP__1: 0,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 24,
    A: 1,
    PO: 21,
    FPCT: 0.917,
    E: 2,
    DP: 1,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 21,
    Last: "Quade",
    First: "Nick",
    GP: 9,
    PA: 17,
    AB: 13,
    AVG: 0,
    OBP: 0.235,
    OPS: 0.235,
    SLG: 0,
    H: 0,
    "1B": 0,
    "2B": 0,
    "3B": 0,
    HR: 0,
    RBI: 3,
    R: 2,
    BB: 2,
    SO: 5,
    "K-L": 2,
    HBP: 2,
    SAC: 0,
    SF: 0,
    ROE: 2,
    FC: 0,
    SB: 2,
    "SB%": 66.67,
    CS: 1,
    PIK: 0,
    QAB: 8,
    "QAB%": 47.06,
    "PA/BB": 8.5,
    "BB/K": 0.4,
    "C%": 61.54,
    HHB: 1,
    "LD%": 0,
    "FB%": 71.43,
    "GB%": 28.57,
    BABIP: 0,
    "BA/RISP": 0,
    LOB: 13,
    "2OUTRBI": 0,
    XBH: 0,
    TB: 0,
    PS: 72,
    "PS/PA": 4.235,
    "2S+3": 4,
    "2S+3%": 23.53,
    "6+": 7,
    "6+%": 41.18,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 26,
    GP__1: 9,
    GS: 8,
    BF: 132,
    "#P": 513,
    W: 1,
    L: 2,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 19,
    R__1: 30,
    ER: 15,
    BB__1: 21,
    SO__1: 32,
    "K-L__1": 15,
    HBP__1: 2,
    ERA: 4.615,
    WHIP: 1.538,
    LOB__1: 19,
    BK: 0,
    PIK__1: 2,
    CS__1: 0,
    SB__1: 14,
    "SB%__1": 100,
    WP: 0,
    BAA: 0.178,
    "P/IP": 19.7,
    "P/BF": 3.886,
    "<3%": 39.39,
    LOO: 21,
    "1ST2OUT": 9,
    "123INN": 7,
    "<13": 8,
    FIP: 2.837,
    "S%": 58.67,
    "FPS%": 55.3,
    "FPSO%": 73.97,
    "FPSW%": 9.59,
    "FPSH%": 13.7,
    "BB/INN": 0.808,
    "0BBINN": 13,
    BBS: 8,
    LOBB: 2,
    LOBBS: 0,
    "SM%": 13.26,
    "K/BF": 0.242,
    "K/BB": 1.524,
    "WEAK%": 70.13,
    "HHB%": 29.87,
    "GO/AO": 0.577,
    HR__1: 0,
    "LD%__1": 20.78,
    "FB%__1": 35.06,
    "GB%__1": 41.89,
    BABIP__1: 0.25,
    "BA/RISP__1": 0.244,
    FB: 55,
    FBS: 41,
    "FBS%": 74.55,
    "FBSW%": 65.45,
    "FBSM%": 18.18,
    CB: 17,
    CBS: 13,
    "CBS%": 76.47,
    "CBSW%": 47.06,
    "CBSM%": 11.76,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 3,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 20,
    OSS: 13,
    "OSS%": 65,
    "OSSW%": 40,
    "OSSM%": 10,
    TC: 15,
    A: 5,
    PO: 2,
    FPCT: 0.467,
    E: 8,
    DP: 0,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 22,
    Last: "Michael",
    First: "Brett",
    GP: 20,
    PA: 76,
    AB: 65,
    AVG: 0.354,
    OBP: 0.44,
    OPS: 0.932,
    SLG: 0.492,
    H: 23,
    "1B": 15,
    "2B": 7,
    "3B": 1,
    HR: 0,
    RBI: 13,
    R: 17,
    BB: 5,
    SO: 15,
    "K-L": 4,
    HBP: 5,
    SAC: 1,
    SF: 0,
    ROE: 6,
    FC: 6,
    SB: 13,
    "SB%": 92.86,
    CS: 1,
    PIK: 0,
    QAB: 47,
    "QAB%": 61.84,
    "PA/BB": 15.2,
    "BB/K": 0.333,
    "C%": 76.92,
    HHB: 28,
    "LD%": 21.57,
    "FB%": 25.49,
    "GB%": 50.98,
    BABIP: 0.46,
    "BA/RISP": 0.357,
    LOB: 40,
    "2OUTRBI": 4,
    XBH: 8,
    TB: 32,
    PS: 322,
    "PS/PA": 4.237,
    "2S+3": 13,
    "2S+3%": 17.11,
    "6+": 19,
    "6+%": 25,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 14,
    GP__1: 8,
    GS: 0,
    BF: 66,
    "#P": 281,
    W: 3,
    L: 1,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 12,
    R__1: 13,
    ER: 6,
    BB__1: 11,
    SO__1: 15,
    "K-L__1": 6,
    HBP__1: 1,
    ERA: 3.429,
    WHIP: 1.643,
    LOB__1: 12,
    BK: 0,
    PIK__1: 1,
    CS__1: 2,
    SB__1: 2,
    "SB%__1": 50,
    WP: 1,
    BAA: 0.222,
    "P/IP": 20.1,
    "P/BF": 4.258,
    "<3%": 34.85,
    LOO: 11,
    "1ST2OUT": 4,
    "123INN": 3,
    "<13": 5,
    FIP: 3.149,
    "S%": 58.72,
    "FPS%": 50,
    "FPSO%": 69.7,
    "FPSW%": 6.06,
    "FPSH%": 21.21,
    "BB/INN": 0.786,
    "0BBINN": 8,
    BBS: 5,
    LOBB: 3,
    LOBBS: 2,
    "SM%": 11.03,
    "K/BF": 0.227,
    "K/BB": 1.364,
    "WEAK%": 66.67,
    "HHB%": 33.33,
    "GO/AO": 0.75,
    HR__1: 0,
    "LD%__1": 20.51,
    "FB%__1": 30.77,
    "GB%__1": 48.72,
    BABIP__1: 0.308,
    "BA/RISP__1": 0.25,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 38,
    A: 6,
    PO: 22,
    FPCT: 0.737,
    E: 10,
    DP: 1,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 23,
    Last: "Hannah",
    First: "Dylan",
    GP: 12,
    PA: 29,
    AB: 23,
    AVG: 0.13,
    OBP: 0.276,
    OPS: 0.45,
    SLG: 0.174,
    H: 3,
    "1B": 2,
    "2B": 1,
    "3B": 0,
    HR: 0,
    RBI: 4,
    R: 6,
    BB: 2,
    SO: 3,
    "K-L": 1,
    HBP: 3,
    SAC: 0,
    SF: 1,
    ROE: 4,
    FC: 0,
    SB: 1,
    "SB%": 50,
    CS: 1,
    PIK: 0,
    QAB: 15,
    "QAB%": 51.72,
    "PA/BB": 14.5,
    "BB/K": 0.667,
    "C%": 86.96,
    HHB: 5,
    "LD%": 14.29,
    "FB%": 52.38,
    "GB%": 33.33,
    BABIP: 0.143,
    "BA/RISP": 0,
    LOB: 19,
    "2OUTRBI": 0,
    XBH: 1,
    TB: 4,
    PS: 101,
    "PS/PA": 3.483,
    "2S+3": 6,
    "2S+3%": 20.69,
    "6+": 8,
    "6+%": 27.59,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 0,
    GP__1: 0,
    GS: 0,
    BF: 0,
    "#P": 0,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 0,
    R__1: 0,
    ER: 0,
    BB__1: 0,
    SO__1: 0,
    "K-L__1": 0,
    HBP__1: 0,
    ERA: 0,
    WHIP: 0,
    LOB__1: 0,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 0,
    BAA: 0,
    "P/IP": 0,
    "P/BF": 0,
    "<3%": 0,
    LOO: 0,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 0,
    FIP: 0,
    "S%": 0,
    "FPS%": 0,
    "FPSO%": 0,
    "FPSW%": 0,
    "FPSH%": 0,
    "BB/INN": 0,
    "0BBINN": 0,
    BBS: 0,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 0,
    "K/BF": 0,
    "K/BB": 0,
    "WEAK%": 0,
    "HHB%": 0,
    "GO/AO": 0,
    HR__1: 0,
    "LD%__1": 0,
    "FB%__1": 0,
    "GB%__1": 0,
    BABIP__1: 0,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 55,
    A: 2,
    PO: 53,
    FPCT: 1,
    E: 0,
    DP: 0,
    TP: 0,
    INN: 58.1,
    PB: 17,
    SB__2: 24,
    "SB-ATT": "24-24",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
  {
    Number: 27,
    Last: "Adams",
    First: "Evan",
    GP: 0,
    PA: 0,
    AB: 0,
    AVG: 0,
    OBP: 0,
    OPS: 0,
    SLG: 0,
    H: 0,
    "1B": 0,
    "2B": 0,
    "3B": 0,
    HR: 0,
    RBI: 0,
    R: 0,
    BB: 0,
    SO: 0,
    "K-L": 0,
    HBP: 0,
    SAC: 0,
    SF: 0,
    ROE: 0,
    FC: 0,
    SB: 0,
    "SB%": 0,
    CS: 0,
    PIK: 0,
    QAB: 0,
    "QAB%": 0,
    "PA/BB": 0,
    "BB/K": 0,
    "C%": 0,
    HHB: 0,
    "LD%": 0,
    "FB%": 0,
    "GB%": 0,
    BABIP: 0,
    "BA/RISP": 0,
    LOB: 0,
    "2OUTRBI": 0,
    XBH: 0,
    TB: 0,
    PS: 0,
    "PS/PA": 0,
    "2S+3": 0,
    "2S+3%": 0,
    "6+": 0,
    "6+%": 0,
    "AB/HR": 0,
    GIDP: 0,
    GITP: 0,
    CI: 0,
    IP: 1,
    GP__1: 1,
    GS: 0,
    BF: 6,
    "#P": 24,
    W: 0,
    L: 0,
    SV: 0,
    SVO: 0,
    BS: 0,
    "SV%": 0,
    H__1: 1,
    R__1: 2,
    ER: 1,
    BB__1: 2,
    SO__1: 1,
    "K-L__1": 1,
    HBP__1: 0,
    ERA: 8,
    WHIP: 3,
    LOB__1: 1,
    BK: 0,
    PIK__1: 0,
    CS__1: 0,
    SB__1: 0,
    "SB%__1": 0,
    WP: 0,
    BAA: 0.25,
    "P/IP": 24,
    "P/BF": 4,
    "<3%": 16.67,
    LOO: 1,
    "1ST2OUT": 0,
    "123INN": 0,
    "<13": 0,
    FIP: 6.8,
    "S%": 45.83,
    "FPS%": 33.33,
    "FPSO%": 50,
    "FPSW%": 0,
    "FPSH%": 50,
    "BB/INN": 2,
    "0BBINN": 0,
    BBS: 1,
    LOBB: 0,
    LOBBS: 0,
    "SM%": 8.33,
    "K/BF": 0.167,
    "K/BB": 0.5,
    "WEAK%": 0,
    "HHB%": 100,
    "GO/AO": 0,
    HR__1: 0,
    "LD%__1": 33.33,
    "FB%__1": 0,
    "GB%__1": 66.67,
    BABIP__1: 0.333,
    "BA/RISP__1": 0,
    FB: 0,
    FBS: 0,
    "FBS%": 0,
    "FBSW%": 0,
    "FBSM%": 0,
    CB: 0,
    CBS: 0,
    "CBS%": 0,
    "CBSW%": 0,
    "CBSM%": 0,
    CT: 0,
    CTS: 0,
    "CTS%": 0,
    "CTSW%": 0,
    "CTSM%": 0,
    SL: 0,
    SLS: 0,
    "SLS%": 0,
    "SLSW%": 0,
    "SLSM%": 0,
    CH: 0,
    CHS: 0,
    "CHS%": 0,
    "CHSW%": 0,
    "CHSM%": 0,
    OS: 0,
    OSS: 0,
    "OSS%": 0,
    "OSSW%": 0,
    "OSSM%": 0,
    TC: 0,
    A: 0,
    PO: 0,
    FPCT: 0,
    E: 0,
    DP: 0,
    TP: 0,
    INN: 0,
    PB: 0,
    SB__2: 0,
    "SB-ATT": "0-0",
    CS__2: 0,
    "CS%": 0,
    PIK__2: 0,
    CI__1: 0,
  },
];

export default players;
